import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Col,
  Form,
  Row,
  Select,
  Typography,
  Input,
  Checkbox,
  InputNumber,
  Button,
  notification,
  message,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import moment from "moment";

import {
  locations,
  clientType,
  leaseType,
  currency,
  calculationType,
  assetAge,
  manufacturingYear,
  assetTypeFL,
  assetTypeOL,
  durationFL,
  durationOL,
  duration8,
  duration10,
  duration12,
  NavigationPath,
  manufacturingYear7,
  manufacturingYear9,
  manufacturingYear11,
} from "../../helpers/constants";
import DodatneInformacije from "./DodatneInformacije/DodatneInformacije";
import ModalProvizija from "./ModalProvizija/ModalProvizija";
import { RESET_COMPANIES } from "./modules/types";
import {
  formatNumber,
  parserNumber,
  formatNumberPostotak,
} from "../../helpers/formater";
import styles from "./Calculator.module.scss";

const { Title, Text, Paragraph } = Typography;
const { Option } = Select;
const { Search } = Input;

const brendPredmeta = [
  { value: "BMW" },
  { value: "AUDI" },
  { value: "MERCEDES" },
  { value: "FORD" },
  { value: "MAZDA" },
];

const locationOptions = [
  {
    value: locations.federacijaBiH,
    label: locations.federacijaBiH,
  },
  {
    value: locations.republikaSrpska,
    label: locations.republikaSrpska,
  },
  {
    value: locations.brckoDistrikt,
    label: locations.brckoDistrikt,
  },
];

const WebKalkulator = ({ isAddOffer, state, actions }) => {
  const dispatch = useDispatch();
  var xirr = require("xirr");
  const { loggedUser, supplier, offerToEdit, companies, brands } = state;

  const [form] = Form.useForm();
  const [podacioKlijentu, setPodacioKlijentu] = useState(null);
  const [kasko, setKasko] = useState(false);
  const [godinaProizvodnje, setGodinaProizvodnje] = useState(false);
  const [pretragaKlijenta, setPretragaKlijenta] = useState(
    !isAddOffer
      ? offerToEdit.clientType === "Fizičko lice"
        ? true
        : false
      : false
  );
  const [dodatneInfo, setDodatneInfo] = useState(
    !isAddOffer
      ? offerToEdit.clientType === "Fizičko lice"
        ? true
        : false
      : false
  );
  const [operativniLeasing, setOperativniLeasing] = useState(
    !isAddOffer
      ? offerToEdit.leaseType === "Operativni leasing"
        ? true
        : false
      : false
  );

  const [recalculateAdditionalCosts, setRecalculateAdditionalCosts] =
    useState(null);

  const [dodatneInfoForm, setDodatneInfoForm] = useState(false);
  const [isProvizijaModalOpen, setIsProvizijaModalOpen] = useState(false);
  const [activeCurrency, setActiveCurrency] = useState("BAM");
  const [netoInputField, setNetoInputField] = useState(
    !isAddOffer ? Math.round(offerToEdit?.netValue / 1.96) : null
  );
  const [ucescePostotakInputField, setUcescePostotakInputField] = useState(
    !isAddOffer
      ? (offerToEdit?.participation / offerToEdit?.netValue) * 100
      : null
  );
  const [ucesceInputField, setUcesceInputField] = useState(
    !isAddOffer ? offerToEdit?.participation / 1.96 : null
  );
  const [anotacijaPostotakInputField, setAnotacijaPostotakInputField] =
    useState(
      !isAddOffer
        ? (offerToEdit?.downPayment / offerToEdit?.netValue) * 100
        : null
    );
  const [anotacijaInputField, setAnotacijaInputField] = useState(
    !isAddOffer ? offerToEdit?.downPayment / 1.96 : null
  );
  const [
    ostatakVrijednostiPostotakInputField,
    setOstatakVrijednostiPostotakInputField,
  ] = useState(
    !isAddOffer
      ? (((offerToEdit.residualValue / netoInputField) * 100) / 1.96).toFixed(2)
      : null
  );
  const [ostatakVrijednostiInputField, setOstatakVrijednostiInputField] =
    useState(!isAddOffer ? offerToEdit.residualValue / 1.96 : null);
  const [trosakObradePostotakInputField, setTrosakObradePostotakInputField] =
    useState(
      !isAddOffer
        ? (offerToEdit.processingFee * 100) / offerToEdit.netValue
        : null
    );
  const [trosakObradeInputField, setTrosakObradeInputField] = useState(
    !isAddOffer ? offerToEdit.processingFee / 1.96 : null
  );
  const [kamataInputField, setKamataInputField] = useState(
    !isAddOffer ? offerToEdit?.interestRate : supplier?.defaultInterestRate
  );

  const [glavnica, setGlavnica] = useState(
    !isAddOffer
      ? (offerToEdit.netValue - offerToEdit.participation) / 1.96
      : null
  );
  const [durationOptions, setDurationOptions] = useState(
    !isAddOffer
      ? offerToEdit.leaseType === "Operativni leasing"
        ? durationOL
        : durationFL
      : null
  );
  const [brandOptions, setBrandOptions] = useState([]);
  const [isBrandDisabled, setIsBrandDisabled] = useState(true);
  const [checkBrandMatch, setCheckBrandMatch] = useState(false);
  const [brandMatch, setBrandMatch] = useState(null);
  const [ukupnaStarost, setUkupnaStarost] = useState(null);
  const [godineStarostiVozila, setGodineStarostiVozila] = useState(null);

  const [trajanjeGodina, setTrajanjeGodina] = useState(
    !isAddOffer ? offerToEdit.duration : null
  );
  const [netoRata, setNetoRata] = useState(null);
  const [EKS, setEKS] = useState(null);

  useEffect(() => {
    // actions.getBrands(supplier?.id);
    // actions.getBrands();
    setBrandOptions(supplier?.brands);
    form.setFieldsValue({
      ["učešće-%"]: !isAddOffer
        ? ((offerToEdit?.participation * 100) / offerToEdit.netValue).toFixed(2)
        : supplier?.defaultParticipation,
    });
    setUcescePostotakInputField(
      !isAddOffer
        ? ((offerToEdit?.participation * 100) / offerToEdit.netValue).toFixed(2)
        : supplier?.defaultParticipation
    );
    form.setFieldsValue({
      ["obrada-%"]: !isAddOffer
        ? ((offerToEdit?.processingFee * 100) / offerToEdit.netValue).toFixed(4)
        : supplier?.defaultProcessingFee,
    });
    setTrosakObradePostotakInputField(supplier?.defaultProcessingFee);

    form.setFieldsValue({
      ["anotacija-%"]: !isAddOffer
        ? ((offerToEdit?.downPayment * 100) / offerToEdit.netValue).toFixed(2)
        : supplier?.defaultDownPayment,
    });
    setAnotacijaPostotakInputField(
      !isAddOffer
        ? ((offerToEdit?.downPayment * 100) / offerToEdit.netValue).toFixed(2)
        : supplier?.defaultDownPayment
    );
    form.setFieldsValue({
      ["kamata"]: !isAddOffer
        ? offerToEdit?.interestRate
        : supplier?.defaultInterestRate,
    });
    setKamataInputField(
      !isAddOffer ? offerToEdit?.interestRate : supplier?.defaultInterestRate
    );
    if (!isAddOffer) {
      setNetoRata(Number(offerToEdit.installment.toFixed(2)));
      form.setFieldsValue({ rata: offerToEdit.installment });
    }
    supplier && setCheckBrandMatch(true);
  }, [supplier]);

  useEffect(() => {
    if (loggedUser) {
      actions.getSupplierById(loggedUser.supplierId);
    }
  }, [loggedUser]);

  useEffect(() => {
    activeCurrency === "EUR" ? convertToEUR() : convertToBAM();
  }, [activeCurrency]);

  useEffect(() => {
    if (glavnica) {
      rataCalculated();
    }
  }, [
    glavnica,
    kamataInputField,
    trajanjeGodina,
    ostatakVrijednostiPostotakInputField,
    recalculateAdditionalCosts,
  ]);

  useEffect(() => {
    if (operativniLeasing) {
      setKamataInputField(supplier?.olInterestRate);
      form.setFieldsValue({
        kamata: supplier?.olInterestRate,
      });
      return;
    }

    if (netoRata) {
      EKSCalculated();
    }
  }, [netoRata, trosakObradePostotakInputField]);

  useEffect(() => {
    if (supplier) {
      const res = supplier?.brands.some(
        (brand) => brand.id === offerToEdit?.brandId
      );
      setBrandMatch(res);
    }
  }, [checkBrandMatch]);

  const convertToEUR = () => {
    setNetoInputField(netoInputField / 1.96);
    form.setFieldsValue({
      neto: netoInputField / 1.96,
      bruto: (netoInputField * 1.17) / 1.96,
      učešće: ucesceInputField / 1.96,
      anotacija: anotacijaInputField / 1.96,
      ostatak: ostatakVrijednostiInputField / 1.96,
      obrada: trosakObradeInputField / 1.96,
      glavnica: glavnica / 1.96,
    });
    setUcesceInputField(ucesceInputField / 1.96);
    setAnotacijaInputField(anotacijaInputField / 1.96);
    setOstatakVrijednostiInputField(ostatakVrijednostiInputField / 1.96);
    setTrosakObradeInputField(trosakObradeInputField / 1.96);
    setGlavnica(glavnica / 1.96);
  };

  const convertToBAM = () => {
    setNetoInputField(netoInputField * 1.96);
    form.setFieldsValue({
      neto: netoInputField && netoInputField * 1.96,
      bruto: netoInputField * 1.17 * 1.96,
      učešće: ucesceInputField * 1.96,
      anotacija: anotacijaInputField * 1.96,
      ostatak: ostatakVrijednostiInputField * 1.96,
      obrada: trosakObradeInputField * 1.96,
      glavnica: glavnica * 1.96,
    });
    setUcesceInputField(ucesceInputField * 1.96);
    setAnotacijaInputField(anotacijaInputField * 1.96);
    setOstatakVrijednostiInputField(ostatakVrijednostiInputField * 1.96);
    setTrosakObradeInputField(trosakObradeInputField * 1.96);
    setGlavnica(glavnica * 1.96);
  };

  const onChangeNeto = (e) => {
    setNetoInputField(e);
    form.setFieldsValue({
      bruto: e * 1.17,
      učešće: e * (ucescePostotakInputField / 100),
      anotacija: e * (anotacijaPostotakInputField / 100),
      ostatak: e * (ostatakVrijednostiPostotakInputField / 100),
      obrada: e * (trosakObradePostotakInputField / 100),
      glavnica: !operativniLeasing
        ? e - e * (ucescePostotakInputField / 100)
        : e -
          e * (anotacijaPostotakInputField / 100) -
          e * (ostatakVrijednostiPostotakInputField / 100),
    });
    setUcesceInputField(e * (ucescePostotakInputField / 100));
    setAnotacijaInputField(e * (anotacijaPostotakInputField / 100));
    setOstatakVrijednostiInputField(
      e * (ostatakVrijednostiPostotakInputField / 100)
    );

    setTrosakObradeInputField(e * (trosakObradePostotakInputField / 100));
    setGlavnica(
      !operativniLeasing
        ? e - e * (ucescePostotakInputField / 100)
        : e -
            e * (anotacijaPostotakInputField / 100) -
            e * (ostatakVrijednostiPostotakInputField / 100)
    );
  };

  const onChangeUcesce = (e) => {
    setUcescePostotakInputField(e);
    form.setFieldsValue({
      učešće: netoInputField * (e / 100),
      glavnica: netoInputField - netoInputField * (e / 100),
    });
    setUcesceInputField(netoInputField * (e / 100));
    setGlavnica(netoInputField - netoInputField * (e / 100));
  };

  const onChangeAnotacija = (e) => {
    setAnotacijaPostotakInputField(e);
    form.setFieldsValue({
      anotacija: netoInputField * (e / 100),
      glavnica:
        netoInputField -
        netoInputField * (e / 100) -
        netoInputField * (ostatakVrijednostiPostotakInputField / 100),
    });
    setAnotacijaInputField(netoInputField * (e / 100));
    setGlavnica(
      netoInputField -
        netoInputField * (e / 100) -
        netoInputField * (ostatakVrijednostiPostotakInputField / 100)
    );
  };

  const onChangeOstatakVrijednosti = (e) => {
    setOstatakVrijednostiPostotakInputField(e);
    form.setFieldsValue({
      ostatak: netoInputField * (e / 100),
    });
    setOstatakVrijednostiInputField(netoInputField * (e / 100));
    if (operativniLeasing) {
      form.setFieldsValue({
        glavnica:
          netoInputField -
          netoInputField * (e / 100) -
          netoInputField * (anotacijaPostotakInputField / 100),
      });
      setGlavnica(
        netoInputField -
          netoInputField * (e / 100) -
          netoInputField * (anotacijaPostotakInputField / 100)
      );
    }
  };

  const onChangeTrosakObrade = (e) => {
    setTrosakObradePostotakInputField(e);
    form.setFieldsValue({
      obrada: netoInputField * (e / 100),
    });
    setTrosakObradeInputField(netoInputField * (e / 100));
  };

  const onFinish = (values) => {
    const offer = {
      supplierId: loggedUser.supplierId,
      brandId: values.brand,
      clientLocation: values.sjedište,
      calculationType:
        values.leasing === "Operativni leasing" ? "Standardni" : values.obračun,
      leaseType: values.leasing,
      currency: values.valuta,
      assetType: values["leasing-predmet"],
      assetAge:
        values.leasing === "Operativni leasing"
          ? "Novo"
          : values["leasing-starost"],
      vehicleBrand: getBrandName(values.brand),
      manufacturingYear: values.proizvodnja
        ? values.proizvodnja
        : new Date().getFullYear().toString(),
      clientType: values.osoba,
      netValue: values.neto,
      grossValue: values.bruto,
      duration: values.trajanje.toString(),
      participation:
        values.leasing === "Operativni leasing" ? 0 : values.učešće,
      downPayment:
        values.leasing === "Operativni leasing" ? values.anotacija : 0,
      residualValue: values.ostatak,
      processingFee: values.obrada,
      interestRate: !operativniLeasing
        ? values.kamata
        : supplier.olInterestRate,
      status: "U postupku",
      companyName: values.klijent,
      clientFullName: null,
      clientDateOfBirth: null,
      clientHouseholdMembers: null,
      clientNetSalary: null,
      clientMealAllowance: null,
      clientTransportAllowance: null,
      installment: values["rata"] ? values["rata"] : null,
      clientAdditionalMonthlyIncome: null,
      eks: values?.eks ? values?.eks : null,
      kaskoFirst:
        values.leasing !== "Operativni leasing" ? 0 : values["kasko-prva"],
      kaskoOther:
        values.leasing !== "Operativni leasing" ? 0 : values["kasko-ostalo"],
      registracijaFirst:
        values.leasing !== "Operativni leasing"
          ? 0
          : values["registracija-prva"],
      registracijaOther:
        values.leasing !== "Operativni leasing"
          ? 0
          : values["registracija-ostalo"],
      aoFirst: values.leasing !== "Operativni leasing" ? 0 : values["ao-prva"],
      aoOther:
        values.leasing !== "Operativni leasing" ? 0 : values["ao-ostalo"],
      servisiFirst:
        values.leasing !== "Operativni leasing" ? 0 : values["servisi-prva"],
      servisiOther:
        values.leasing !== "Operativni leasing" ? 0 : values["servisi-ostalo"],
      gumeFirst:
        values.leasing !== "Operativni leasing" ? 0 : values["gume-prva"],
      gumeOther:
        values.leasing !== "Operativni leasing" ? 0 : values["gume-ostalo"],
      troskoviFirst:
        values.leasing !== "Operativni leasing" ? 0 : values["troskovi-prva"],
      troskoviOther:
        values.leasing !== "Operativni leasing" ? 0 : values["troskovi-ostalo"],
      kilometraza:
        values.leasing !== "Operativni leasing" ? null : values["kilometraza"],
    };

    if (dodatneInfo) {
      setPodacioKlijentu(offer);
      setDodatneInfoForm(true);
      return;
    }

    isAddOffer
      ? actions.createOffer(offer)
      : actions.updateOfferById(offer, offerToEdit.id);
  };

  const onFinishDodatneInfo = (values) => {
    const offer = {
      supplierId: podacioKlijentu.supplierId,
      brandId: podacioKlijentu.brandId,
      clientLocation: podacioKlijentu.clientLocation,
      calculationType: podacioKlijentu.calculationType,
      leaseType: podacioKlijentu.leaseType,
      currency: podacioKlijentu.currency,
      assetType: podacioKlijentu.assetType,
      assetAge: podacioKlijentu.assetAge,
      vehicleBrand: podacioKlijentu.vehicleBrand,
      manufacturingYear: podacioKlijentu.manufacturingYear
        ? podacioKlijentu.manufacturingYear
        : new Date().getFullYear().toString(),
      clientType: podacioKlijentu.clientType,
      netValue: podacioKlijentu.netValue,
      grossValue: podacioKlijentu.grossValue,
      duration: podacioKlijentu.duration,
      participation: podacioKlijentu.participation,
      downPayment: podacioKlijentu.downPayment,
      residualValue: podacioKlijentu.residualValue,
      processingFee: podacioKlijentu.processingFee,
      interestRate: podacioKlijentu.interestRate,
      status: "U postupku",
      companyName: values.klijentFL,
      clientFullName: values.klijentFL,
      clientDateOfBirth: values.datum?.$d,
      clientHouseholdMembers: values.domacinstvo ? values.domacinstvo : null,
      clientNetSalary: values["neto-plata"] ? values["neto-plata"] : null,
      clientMealAllowance: values.obrok ? values.obrok : null,
      clientTransportAllowance: values.naknada ? values.naknada : null,
      installment: podacioKlijentu.installment,
      clientAdditionalMonthlyIncome: values["prihodi-dodatni"]
        ? values["prihodi-dodatni"]
        : null,
      eks: podacioKlijentu?.eks ? podacioKlijentu?.eks : null,
    };

    isAddOffer
      ? actions.createOffer(offer)
      : actions.updateOfferById(offer, offerToEdit.id);
  };

  const onChange = (e) => {};

  const onSearch = (value) => {
    if (value.length < 4) {
      dispatch({
        type: RESET_COMPANIES,
      });
      return;
    }
    actions.getCompanies(value);
  };

  const onClickBamEur = () => {
    activeCurrency === "BAM"
      ? setActiveCurrency("EUR")
      : setActiveCurrency("BAM");
  };

  const onChangeGodinaProizodnje = (value) => {
    value === "Polovno"
      ? setGodinaProizvodnje(true)
      : setGodinaProizvodnje(false);
  };

  const onChangeVrstaOsobe = (value) => {
    if (value === "Fizičko lice") {
      setDodatneInfo(true);
      setPretragaKlijenta(true);
      //setKasko(false);
      form.setFieldsValue({
        klijent: null,
      });
      if (!operativniLeasing) {
        form.setFieldsValue({
          kamata: supplier?.minPhysicalInterestRate,
        });
        setKamataInputField(supplier?.minPhysicalInterestRate);
      }
      return;
    }
    setDodatneInfo(false);
    setPretragaKlijenta(false);
    // setKasko(true);
    form.setFieldsValue({
      pretraga: false,
    });
    if (!operativniLeasing) {
      form.setFieldsValue({
        kamata: supplier?.defaultInterestRate,
      });
      setKamataInputField(supplier?.defaultInterestRate);
    }
  };

  const onChangeVrstaLeasinga = (value) => {
    if (value === "Operativni leasing") {
      setKamataInputField(supplier?.olInterestRate);
      form.setFieldsValue({
        kamata: supplier?.olInterestRate,
      });
      setOperativniLeasing(true);
      form.setFieldsValue({
        glavnica:
          netoInputField -
          netoInputField * (ostatakVrijednostiPostotakInputField / 100),
        trajanje: null,
        "leasing-predmet": null,
        brand: null,
      });
      setGlavnica(
        netoInputField -
          netoInputField * (ostatakVrijednostiPostotakInputField / 100)
      );
      setIsBrandDisabled(true);
      setDurationOptions(durationOL);
      return;
    }
    setOperativniLeasing(false);
    if (dodatneInfo) {
      form.setFieldsValue({
        kamata: supplier?.minPhysicalInterestRate,
      });
      setKamataInputField(supplier?.minPhysicalInterestRate);
    } else {
      form.setFieldsValue({
        kamata: supplier?.defaultInterestRate,
      });
      setKamataInputField(supplier?.defaultInterestRate);
    }

    form.setFieldsValue({
      glavnica:
        netoInputField - netoInputField * (ucescePostotakInputField / 100),
      trajanje: null,
      "leasing-predmet": null,
      brand: null,
    });
    setGlavnica(
      netoInputField - netoInputField * (ucescePostotakInputField / 100)
    );
    setIsBrandDisabled(true);
    setDurationOptions(durationFL);
  };

  const onChangeVrstaLeasingPredmeta = (value) => {
    form.setFieldsValue({ brand: null });

    const result = supplier?.brands.filter((brand) =>
      brand.assetType.includes(value)
    );
    setBrandOptions(result);
    setIsBrandDisabled(false);

    switch (value) {
      case "Laka dostavna vozila do 3,5 tone":
        return setUkupnaStarost(8), setGodineStarostiVozila(manufacturingYear7);
      case "Teška teretna vozila preko 3,5 tone":
      case "Građevinske mašine":
        return (
          setUkupnaStarost(12), setGodineStarostiVozila(manufacturingYear11)
        );

      default:
        return form.getFieldsValue().leasing === "Operativni leasing"
          ? (setDurationOptions(durationOL),
            setTrajanjeGodina(null),
            form.setFieldsValue({ trajanje: null }))
          : (setDurationOptions(durationFL),
            setTrajanjeGodina(null),
            form.setFieldsValue({ trajanje: null }));
    }
  };

  const onChangeBrand = (brandId) => {
    const predmet = form.getFieldsValue()["leasing-predmet"];
    if (
      predmet === "Laka dostavna vozila do 3,5 tone" ||
      predmet === "Teška teretna vozila preko 3,5 tone" ||
      predmet === "Građevinske mašine"
    ) {
      return;
    }

    const brandGroup = supplier?.brands.find(
      (brand) => brand.id === brandId
    ).group;

    switch (brandGroup) {
      case "A":
      case "B":
        return (
          setUkupnaStarost(10), setGodineStarostiVozila(manufacturingYear9)
        );
      case "C":
        return setUkupnaStarost(8), setGodineStarostiVozila(manufacturingYear7);
    }
  };

  const onChangeTrajanjeGodina = (e) => {
    setTrajanjeGodina(e);

    if (operativniLeasing) {
      let defOstatakVrijednosti;
      switch (e) {
        case "1":
          defOstatakVrijednosti = 80;
          break;
        case "2":
          defOstatakVrijednosti = 60;
          break;
        case "3":
          defOstatakVrijednosti = 45;
          break;
        case "4":
          defOstatakVrijednosti = 35;
          break;
      }
      form.setFieldsValue({
        ["ostatak-%"]: defOstatakVrijednosti,
      });
      setOstatakVrijednostiPostotakInputField(defOstatakVrijednosti);

      form.setFieldsValue({
        ["ostatak"]: netoInputField * (defOstatakVrijednosti / 100),
      });
      setOstatakVrijednostiInputField(
        netoInputField * (defOstatakVrijednosti / 100)
      );
    }
  };

  const provjeraTrajanjaGodinaLeasinga = (godinaProizvodnje) => {
    if (!ukupnaStarost) {
      return;
    }
    const currentYear = new Date().getFullYear();
    const starostPredmeta =
      ukupnaStarost - (currentYear - godinaProizvodnje + 1);
    const trajanjeGodinaMenu = [];
    for (let index = 1; index <= starostPredmeta; index++) {
      trajanjeGodinaMenu.push({
        value: index.toString(),
      });
    }
    setDurationOptions(trajanjeGodinaMenu);
  };

  const EKSCalculated = () => {
    const prvoPlacanje =
      activeCurrency === "EUR"
        ? (ucesceInputField + trosakObradeInputField) * 1.96
        : ucesceInputField + trosakObradeInputField;

    const netoVrijednost =
      activeCurrency === "EUR" ? netoInputField * 1.96 : netoInputField;

    const todayDate = new Date();
    const yesterdayDate = new Date(todayDate);
    yesterdayDate.setDate(yesterdayDate.getDate() - 1);

    let eksArray = [
      { amount: -netoVrijednost, when: todayDate },
      { amount: prvoPlacanje, when: yesterdayDate },
    ];

    for (let i = 0; i < trajanjeGodina * 12; i++) {
      eksArray.push({
        amount: activeCurrency === "EUR" ? netoRata * 1.96 : netoRata,
        when: new Date(
          todayDate.getFullYear(),
          todayDate.getMonth() + i + 1,
          15
        ),
      });
    }

    var EKSvalue = xirr(eksArray);

    setEKS(EKSvalue);
    form.setFieldsValue({ eks: (EKSvalue * 100).toFixed(2) });
  };

  function calculatePOM(C18, C16, C17) {
    if (!C18 || !C16 || !C17) {
      return;
    }
    return (
      Math.pow(C18, C16 * C17) * ((C18 - 1) / (Math.pow(C18, C16 * C17) - 1))
    );
  }

  function calculateOdkup(brMjeseci, brRata, ostatak, kta) {
    return (brMjeseci / brRata) * ostatak * (kta / 12);
  }

  function pmt(rate, nper, pv, fv = 0, type = 0) {
    if (rate === 0) {
      return -(pv + fv) / nper;
    }

    const pow = Math.pow(1 + rate, nper);
    let pmt = (rate * (pv * pow + fv)) / ((type ? 1 + rate : 1) * (pow - 1));

    return -pmt;
  }

  function calculateOperativniOdkup(ostatak, kamata) {
    if (!kamata) {
      return;
    }
    return (ostatak * kamata) / 12 / 100;
  }

  const rataCalculated = () => {
    if (!operativniLeasing) {
      const monthlyRate = kamataInputField / 100 / 12;
      const numberOfPayments = trajanjeGodina * 12;

      const netoRata = pmt(
        monthlyRate,
        numberOfPayments,
        -glavnica,
        ostatakVrijednostiInputField
      );

      setNetoRata(Number(netoRata.toFixed(2)));
      form.setFieldsValue({ rata: netoRata });
    } else {
      const C18 = 1 + kamataInputField / 100 / 12;
      const C16 = trajanjeGodina;
      const C17 = 12;
      const POM = calculatePOM(C18, C16, C17);

      if (!POM) {
        return;
      }
      const R = glavnica * POM;

      const S = calculateOperativniOdkup(
        ostatakVrijednostiInputField,
        kamataInputField
      );
      let dodatniTroskovi = 0;
      //kalkulacija dodatnih troskova za operativni lizing
      if (operativniLeasing) {
        const kaskoPrvaGodina = form.getFieldsValue()["kasko-prva"]
          ? form.getFieldsValue()["kasko-prva"] +
            (form.getFieldsValue()["kasko-prva"] / 100) * kamataInputField
          : 0;

        const kaskoOstalo = form.getFieldsValue()["kasko-ostalo"]
          ? form.getFieldsValue()["kasko-ostalo"]
          : 0;

        const gumePrvaGodina = form.getFieldsValue()["gume-prva"]
          ? form.getFieldsValue()["gume-prva"] +
            (form.getFieldsValue()["gume-prva"] / 100) * kamataInputField
          : 0;

        const gumeOstalo = form.getFieldsValue()["gume-ostalo"]
          ? form.getFieldsValue()["gume-ostalo"]
          : 0;

        const troskoviPrvaGodina = form.getFieldsValue()["troskovi-prva"]
          ? form.getFieldsValue()["troskovi-prva"] +
            (form.getFieldsValue()["troskovi-prva"] / 100) * kamataInputField
          : 0;

        const troskoviOstalo = form.getFieldsValue()["troskovi-ostalo"]
          ? form.getFieldsValue()["troskovi-ostalo"]
          : 0;

        const servisiPrvaGodina = form.getFieldsValue()["servisi-prva"]
          ? form.getFieldsValue()["servisi-prva"] +
            (form.getFieldsValue()["servisi-prva"] / 100) * kamataInputField
          : 0;

        const servisiOstalo = form.getFieldsValue()["servisi-ostalo"]
          ? form.getFieldsValue()["servisi-ostalo"]
          : 0;

        const aoPrvaGodina = form.getFieldsValue()["ao-prva"]
          ? form.getFieldsValue()["ao-prva"] +
            (form.getFieldsValue()["ao-prva"] / 100) * kamataInputField
          : 0;

        const aoOstalo = form.getFieldsValue()["ao-ostalo"]
          ? form.getFieldsValue()["ao-ostalo"]
          : 0;

        const registracijaPrva = form.getFieldsValue()["registracija-prva"]
          ? form.getFieldsValue()["registracija-prva"] +
            (form.getFieldsValue()["registracija-prva"] / 100) *
              kamataInputField
          : 0;

        const registracijaOstalo = form.getFieldsValue()["registracija-ostalo"]
          ? form.getFieldsValue()["registracija-ostalo"]
          : 0;

        dodatniTroskovi =
          kaskoPrvaGodina +
          kaskoOstalo +
          gumePrvaGodina +
          gumeOstalo +
          troskoviPrvaGodina +
          troskoviOstalo +
          servisiPrvaGodina +
          servisiOstalo +
          aoPrvaGodina +
          aoOstalo +
          registracijaPrva +
          registracijaOstalo;
        dodatniTroskovi = dodatniTroskovi / (trajanjeGodina * 12);
      }
      const netoRata = R + S + dodatniTroskovi;

      setNetoRata(Number(netoRata.toFixed(2)));
      form.setFieldsValue({ rata: netoRata });
    }
  };

  const getBrandName = (brandId) => {
    const result = supplier?.brands?.find((brand) => brand.id === brandId);
    return result?.name;
  };

  const goBack = () => {
    setDodatneInfoForm(false);
  };

  const shouldDisableGodinaProizvodnje = () => {
    return (
      !form.getFieldsValue()["leasing-predmet"] ||
      !form.getFieldsValue()["brand"]
    );
  };

  const shouldDisableGodineTrajanja = () => {
    if (form.getFieldsValue().leasing === "Operativni leasing") {
      return (
        !form.getFieldsValue()["leasing-predmet"] ||
        !form.getFieldsValue()["brand"]
      );
    }

    if (form.getFieldsValue()["leasing-starost"] === "Novo") {
      return (
        !form.getFieldsValue()["leasing-predmet"] ||
        !form.getFieldsValue()["brand"]
      );
    }
    return (
      !form.getFieldsValue()["leasing-predmet"] ||
      !form.getFieldsValue()["brand"] ||
      !form.getFieldsValue()["proizvodnja"]
    );
  };

  const minOstatakVrijednostiCalculated = () => {
    switch (trajanjeGodina) {
      case "1":
        return 80;
      case "2":
        return 60;
      case "3":
        return 40;
      case "4":
        return 20;
    }
  };

  return (
    <div>
      {!dodatneInfoForm ? (
        <>
          <div className="py-6 px-8">
            <Title className="text-dark-blue text-xl font-bold m-0 ">
              {supplier?.companyName}
            </Title>
          </div>
          <div className="h-4 bg-padding-white"></div>
          <div>
            <Form
              className="pt-8"
              form={form}
              layout="vertical"
              onFinish={onFinish}
              onFieldsChange={onChange}
            >
              <Text className="text-dark-blue font-bold text-base leading-4 pl-8">
                PODACI O KLIJENTU
              </Text>

              <Row className="px-8 pt-6 pb-7">
                <Col span={8}>
                  <div className="w-[85%]">
                    <Form.Item
                      initialValue={
                        !isAddOffer ? offerToEdit?.clientLocation : null
                      }
                      colon={false}
                      name="sjedište"
                      label="Sjedište klijenta"
                      rules={[
                        {
                          required: true,
                          message: "Odaberite lokaciju sjedišta klijenta!",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Odaberite lokaciju sjedišta klijenta"
                        options={locationOptions}
                      ></Select>
                    </Form.Item>

                    <Form.Item
                      initialValue={
                        !isAddOffer ? offerToEdit?.clientType : null
                      }
                      colon={false}
                      name="osoba"
                      label="Vrsta osobe"
                      rules={[
                        {
                          required: true,
                          message: "Odaberite vrstu osobe!",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Odaberite vrstu osobe"
                        options={clientType}
                        onChange={onChangeVrstaOsobe}
                      ></Select>
                    </Form.Item>
                  </div>
                </Col>
                <Col span={8}>
                  <Form.Item
                    initialValue={!isAddOffer ? offerToEdit?.companyName : null}
                    className="mb-1"
                    colon={false}
                    name="klijent"
                    label="Naziv klijenta"
                    rules={[
                      {
                        required: true,
                        message: "Odaberite klijenta!",
                      },
                    ]}
                  >
                    {!pretragaKlijenta ? (
                      <Select
                        showSearch
                        placeholder="Pretraži kompanije po imenu ili ID broju"
                        defaultActiveFirstOption={false}
                        suffixIcon={null}
                        filterOption={false}
                        onSearch={onSearch}
                        notFoundContent={null}
                        options={companies?.map((company) => ({
                          value: company.name,
                          label: company.name,
                        }))}
                      />
                    ) : (
                      <Input
                        placeholder={`${
                          !dodatneInfo
                            ? "Pretraži kompanije po imenu ili ID broju"
                            : "Unesite ime i prezime"
                        }`}
                      />
                    )}
                  </Form.Item>

                  {!dodatneInfo && (
                    <>
                      <Form.Item
                        className="mb-1"
                        name="pretraga"
                        valuePropName="checked"
                      >
                        <Checkbox
                          onChange={(e) => {
                            !dodatneInfo &&
                              setPretragaKlijenta(e.target.checked);
                            form.setFieldsValue({
                              klijent: null,
                            });
                          }}
                          className="text-dark-blue"
                        >
                          Isključi automatsku pretragu
                        </Checkbox>
                      </Form.Item>

                      <div className="py-2 px-4 border rounded-md">
                        <div className="flex items-center gap-2 mb-2">
                          <InfoCircleOutlined className="text-light-blue-login text-base" />
                          <Text className="text-[10px]">Napomena</Text>
                        </div>
                        <Paragraph className="text-[10px] leading-3 italic text-black text-opacity-40 m-0">
                          U slučaju da želite ručno upisti naziv klijenta
                          isključite automatsku pretragu klikom na checkbox!
                        </Paragraph>
                      </div>
                    </>
                  )}
                </Col>
                <Col span={7} className=" ml-10">
                  <div className="w-[95%]">
                    <Form.Item
                      initialValue={!isAddOffer ? offerToEdit?.leaseType : null}
                      colon={false}
                      name="leasing"
                      label="Vrsta leasinga"
                      rules={[
                        {
                          required: true,
                          message: "Odaberite vrstu leasinga!",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Odaberite vrstu leasinga"
                        options={leaseType}
                        onChange={onChangeVrstaLeasinga}
                      ></Select>
                    </Form.Item>
                    <Form.Item
                      initialValue={!isAddOffer ? offerToEdit?.currency : null}
                      colon={false}
                      name="valuta"
                      label="Valuta"
                      rules={[
                        {
                          required: true,
                          message: "Odaberite valutu!",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Odaberite valutu"
                        options={currency}
                      ></Select>
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <div className="h-4 bg-padding-white"></div>

              <Row className="px-8 pt-6">
                <Col span={8}>
                  <div className="w-[85%]">
                    {!operativniLeasing && (
                      <Form.Item
                        initialValue={
                          !isAddOffer ? offerToEdit?.calculationType : null
                        }
                        colon={false}
                        name="obračun"
                        label="Obračun"
                        rules={[
                          {
                            required: true,
                            message: "Odaberite način obračuna!",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Odaberite način obračuna"
                          options={calculationType}
                        ></Select>
                      </Form.Item>
                    )}

                    <Form.Item
                      initialValue={!isAddOffer ? offerToEdit?.assetType : null}
                      colon={false}
                      name="leasing-predmet"
                      label="Vrsta leasing predmeta"
                      rules={[
                        {
                          required: true,
                          message: "Odaberite vrstu leasing predmeta!",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Odaberite vrstu leasing predmeta"
                        options={!operativniLeasing ? assetTypeFL : assetTypeOL}
                        onChange={onChangeVrstaLeasingPredmeta}
                      ></Select>
                    </Form.Item>

                    {operativniLeasing && (
                      <>
                        <Form.Item
                          colon={false}
                          name="kasko-prva"
                          label="Kasko (1. godina)"
                          onChange={(e) => setRecalculateAdditionalCosts(e)}
                          initialValue={
                            !isAddOffer ? offerToEdit?.kaskoFirst : null
                          }
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Unesite vrijednost!",
                          //   },
                          // ]}
                        >
                          <InputNumber
                            className="w-full"
                            parser={(value) => parserNumber(value)}
                            placeholder="Unesite vrijednost"
                          />
                        </Form.Item>

                        <Form.Item
                          colon={false}
                          name="kasko-ostalo"
                          label="Kasko (zbir ostalih godina)"
                          onChange={(e) => setRecalculateAdditionalCosts(e)}
                          initialValue={
                            !isAddOffer ? offerToEdit?.kaskoOther : null
                          }
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Unesite vrijednost!",
                          //   },
                          // ]}
                        >
                          <InputNumber
                            className="w-full"
                            parser={(value) => parserNumber(value)}
                            placeholder="Unesite vrijednost"
                          />
                        </Form.Item>

                        <Form.Item
                          colon={false}
                          name="servisi-prva"
                          label="Redovni servisi (1. godina)"
                          onChange={(e) => setRecalculateAdditionalCosts(e)}
                          initialValue={
                            !isAddOffer ? offerToEdit?.servisiFirst : null
                          }
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Unesite vrijednost!",
                          //   },
                          // ]}
                        >
                          <InputNumber
                            className="w-full"
                            parser={(value) => parserNumber(value)}
                            placeholder="Unesite vrijednost"
                          />
                        </Form.Item>

                        <Form.Item
                          colon={false}
                          name="servisi-ostalo"
                          label="Redovni servisi (zbir ostalih godina)"
                          onChange={(e) => setRecalculateAdditionalCosts(e)}
                          initialValue={
                            !isAddOffer ? offerToEdit?.servisiOther : null
                          }
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Unesite vrijednost!",
                          //   },
                          // ]}
                        >
                          <InputNumber
                            className="w-full"
                            parser={(value) => parserNumber(value)}
                            placeholder="Unesite vrijednost"
                          />
                        </Form.Item>
                      </>
                    )}

                    {!operativniLeasing ? (
                      <div className="flex gap-4">
                        <Form.Item
                          colon={false}
                          label="Učešće"
                          name="učešće-%"
                          rules={[
                            {
                              required: true,
                              message: "Obavezno polje!",
                            },
                          ]}
                        >
                          <InputNumber
                            // formatter={(value) => formatNumberPostotak(value)}
                            type="number"
                            className="w-full mr-3"
                            min={supplier?.minParticipation}
                            max={supplier?.maxParticipation}
                            onChange={onChangeUcesce}
                            suffix="%"
                          />
                        </Form.Item>

                        <Form.Item
                          colon={false}
                          label=" "
                          name="učešće"
                          rules={[
                            {
                              required: true,
                              message: "Obavezno polje!",
                            },
                          ]}
                        >
                          <InputNumber
                            formatter={(value) => formatNumber(value)}
                            parser={(value) => parserNumber(value)}
                            disabled
                            value={ucesceInputField}
                            // type="number"
                            className="w-full"
                          />
                        </Form.Item>
                      </div>
                    ) : (
                      <div className="flex gap-4">
                        <Form.Item
                          colon={false}
                          label="Akontacija"
                          name="anotacija-%"
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Obavezno polje!",
                          //   },
                          // ]}
                        >
                          <InputNumber
                            type="number"
                            className="w-full mr-3"
                            value={anotacijaPostotakInputField}
                            min={supplier?.minDownPayment}
                            max={supplier?.maxDownPayment}
                            onChange={onChangeAnotacija}
                            suffix="%"
                          />
                        </Form.Item>

                        <Form.Item
                          colon={false}
                          label=" "
                          name="anotacija"
                          rules={[
                            {
                              required: true,
                              message: "Obavezno polje!",
                            },
                          ]}
                        >
                          <InputNumber
                            formatter={(value) => formatNumber(value)}
                            parser={(value) => parserNumber(value)}
                            disabled
                            value={anotacijaInputField}
                            // type="number"
                            className="w-full"
                          />
                        </Form.Item>
                      </div>
                    )}

                    <Form.Item
                      colon={false}
                      label="Neto Vrijednost"
                      name="neto"
                      rules={[
                        {
                          required: true,
                          message: "Obavezno polje!",
                        },
                      ]}
                    >
                      <InputNumber
                        className="w-full"
                        min={0}
                        formatter={(value) => formatNumber(value)}
                        parser={(value) => parserNumber(value)}
                        onChange={(e) => onChangeNeto(e)}
                      />
                    </Form.Item>

                    <Form.Item
                      colon={false}
                      label="Bruto Vrijednost"
                      name="bruto"
                      rules={[
                        {
                          required: true,
                          message: "Obavezno polje!",
                        },
                      ]}
                    >
                      <InputNumber
                        disabled
                        formatter={(value) => formatNumber(value)}
                        parser={(value) => parserNumber(value)}
                        className="w-full"
                      />
                    </Form.Item>

                    <Form.Item>
                      <Button
                        htmlType="button"
                        onClick={onClickBamEur}
                        className={`text-sm text-dark-blue bg-bam/eur font-medium w-[132px] border-light-blue shadow-sm ${
                          kasko ? "mt-[90px]" : "mt-1"
                        }`}
                      >
                        BAM / EUR
                      </Button>
                    </Form.Item>
                  </div>
                </Col>
                <Col span={8}>
                  <div className="w-[89%]">
                    {!operativniLeasing && (
                      <Form.Item
                        initialValue={
                          !isAddOffer ? offerToEdit?.assetAge : null
                        }
                        colon={false}
                        name="leasing-starost"
                        label="Starost leasing predmeta"
                        rules={[
                          {
                            required: true,
                            message: "Odaberite starost leasing predmeta!",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Odaberite starost leasing predmeta"
                          options={assetAge}
                          onChange={onChangeGodinaProizodnje}
                        ></Select>
                      </Form.Item>
                    )}

                    {brandMatch !== null && (
                      <Form.Item
                        initialValue={
                          !isAddOffer
                            ? brandMatch
                              ? offerToEdit?.brandId
                              : null
                            : null
                        }
                        colon={false}
                        name="brand"
                        label="Brand leasing predmeta"
                        rules={[
                          {
                            required: true,
                            message: "Odaberite brand leasing predmeta!",
                          },
                        ]}
                      >
                        <Select
                          disabled={isBrandDisabled}
                          placeholder="Odaberite brand leasing predmeta"
                          options={brandOptions?.map((brand) => ({
                            value: brand.id,
                            label: brand.name,
                          }))}
                          onChange={onChangeBrand}
                        ></Select>
                      </Form.Item>
                    )}

                    {operativniLeasing && (
                      <>
                        <Form.Item
                          colon={false}
                          name="ao-prva"
                          label="AO (1. godina)"
                          initialValue={
                            !isAddOffer ? offerToEdit?.aoFirst : null
                          }
                          onChange={(e) => setRecalculateAdditionalCosts(e)}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Unesite vrijednost!",
                          //   },
                          // ]}
                        >
                          <InputNumber
                            className="w-full"
                            parser={(value) => parserNumber(value)}
                            placeholder="Unesite vrijednost"
                          />
                        </Form.Item>

                        <Form.Item
                          colon={false}
                          name="ao-ostalo"
                          label="AO (zbir ostalih godina)"
                          initialValue={
                            !isAddOffer ? offerToEdit?.aoOther : null
                          }
                          onChange={(e) => setRecalculateAdditionalCosts(e)}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Unesite vrijednost!",
                          //   },
                          // ]}
                        >
                          <InputNumber
                            className="w-full"
                            placeholder="Unesite vrijednost"
                          />
                        </Form.Item>

                        <Form.Item
                          colon={false}
                          name="gume-prva"
                          label="Zimske / Ljetne gume  (1. godina)"
                          initialValue={
                            !isAddOffer ? offerToEdit?.gumeFirst : null
                          }
                          onChange={(e) => setRecalculateAdditionalCosts(e)}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Unesite vrijednost!",
                          //   },
                          // ]}
                        >
                          <InputNumber
                            className="w-full"
                            parser={(value) => parserNumber(value)}
                            placeholder="Unesite vrijednost"
                          />
                        </Form.Item>

                        <Form.Item
                          colon={false}
                          name="gume-ostalo"
                          label="Zimske / Ljetne gume  (zbir ostalih godina)"
                          initialValue={
                            !isAddOffer ? offerToEdit?.gumeOther : null
                          }
                          onChange={(e) => setRecalculateAdditionalCosts(e)}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Unesite vrijednost!",
                          //   },
                          // ]}
                        >
                          <InputNumber
                            className="w-full"
                            placeholder="Unesite vrijednost"
                          />
                        </Form.Item>
                      </>
                    )}

                    <div className="flex gap-2">
                      <Form.Item
                        initialValue={
                          !isAddOffer
                            ? ostatakVrijednostiPostotakInputField
                            : null
                        }
                        colon={false}
                        label="Ostatak vrijednosti"
                        name="ostatak-%"
                        rules={[
                          {
                            required: true,
                            message: "Obavezno polje!",
                          },
                        ]}
                      >
                        <InputNumber
                          // formatter={(value) => formatNumberPostotak(value)}
                          onChange={onChangeOstatakVrijednosti}
                          type="number"
                          className="w-full mr-6"
                          min={
                            !operativniLeasing
                              ? 0
                              : minOstatakVrijednostiCalculated()
                          }
                          max={100}
                          suffix="%"
                        />
                      </Form.Item>

                      <Form.Item
                        colon={false}
                        label=" "
                        name="ostatak"
                        rules={[
                          {
                            required: true,
                            message: "Obavezno polje!",
                          },
                        ]}
                      >
                        <InputNumber
                          formatter={(value) => formatNumber(value)}
                          parser={(value) => parserNumber(value)}
                          disabled
                          className="w-full"
                        />
                      </Form.Item>
                    </div>

                    {!operativniLeasing && (
                      <Form.Item
                        initialValue={kamataInputField}
                        colon={false}
                        label="Kamata"
                        name="kamata"
                        rules={[
                          {
                            required: true,
                            message: "Obavezno polje!",
                          },
                        ]}
                      >
                        <InputNumber
                          className="w-full"
                          type="number"
                          onChange={(e) => setKamataInputField(e)}
                          min={
                            !dodatneInfo
                              ? supplier?.minInterestRate
                              : supplier?.minPhysicalInterestRate
                          }
                          max={!dodatneInfo ? supplier?.maxInterestRate : 100}
                          suffix="%"
                        />
                      </Form.Item>
                    )}

                    {!operativniLeasing ? (
                      <Form.Item colon={false} label="EKS" name="eks">
                        <InputNumber
                          disabled
                          className="w-full"
                          min={0}
                          max={100}
                          suffix="%"
                        />
                      </Form.Item>
                    ) : (
                      <div className="h-[172px]"></div>
                    )}

                    {!loggedUser?.hidebuttonProvision && (
                      <Form.Item>
                        <Button
                          disabled={!trosakObradeInputField}
                          htmlType="button"
                          onClick={() => setIsProvizijaModalOpen(true)}
                          className={`text-sm text-white bg-green-izracun font-medium w-full border-light-blue shadow-sm ${
                            kasko ? "mt-[90px]" : "mt-1"
                          }`}
                        >
                          IZRAČUN PROVIZIJE
                        </Button>
                      </Form.Item>
                    )}
                  </div>
                </Col>
                <Col span={7} className=" ml-10">
                  <div className="w-[95%]">
                    {!operativniLeasing &&
                      (godinaProizvodnje ||
                      offerToEdit?.assetAge === "Polovno" ? (
                        <Form.Item
                          initialValue={
                            !isAddOffer ? offerToEdit?.manufacturingYear : null
                          }
                          colon={false}
                          name="proizvodnja"
                          label="Godina proizvodnje"
                          rules={[
                            {
                              required: true,
                              message: "Odaberite godinu porizvodnje!",
                            },
                          ]}
                        >
                          <Select
                            disabled={shouldDisableGodinaProizvodnje()}
                            type="number"
                            placeholder="Odaberite godinu porizvodnje"
                            options={godineStarostiVozila}
                            onChange={(e) => provjeraTrajanjaGodinaLeasinga(e)}
                          ></Select>
                        </Form.Item>
                      ) : (
                        <div className="h-[86px]"></div>
                      ))}

                    <Form.Item
                      initialValue={
                        !isAddOffer ? offerToEdit?.duration : trajanjeGodina
                      }
                      colon={false}
                      name="trajanje"
                      label="Trajanje (godina)"
                      rules={[
                        {
                          required: true,
                          message: "Odaberite trajanje!",
                        },
                      ]}
                    >
                      <Select
                        disabled={shouldDisableGodineTrajanja()}
                        placeholder="Odaberite trajanje"
                        options={durationOptions}
                        onChange={(e) => onChangeTrajanjeGodina(e)}
                      ></Select>
                    </Form.Item>
                    {/*  */}

                    {operativniLeasing && (
                      <>
                        <Form.Item
                          colon={false}
                          name="registracija-prva"
                          label="Registracija (1. godina)"
                          initialValue={
                            !isAddOffer ? offerToEdit?.registracijaFirst : null
                          }
                          onChange={(e) => setRecalculateAdditionalCosts(e)}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Unesite vrijednost!",
                          //   },
                          // ]}
                        >
                          <InputNumber
                            className="w-full"
                            parser={(value) => parserNumber(value)}
                            placeholder="Unesite vrijednost"
                          />
                        </Form.Item>

                        <Form.Item
                          colon={false}
                          name="registracija-ostalo"
                          label="Registracija (zbir ostalih godina)"
                          initialValue={
                            !isAddOffer ? offerToEdit?.registracijaOther : null
                          }
                          onChange={(e) => setRecalculateAdditionalCosts(e)}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Unesite vrijednost!",
                          //   },
                          // ]}
                        >
                          <InputNumber
                            className="w-full"
                            parser={(value) => parserNumber(value)}
                            placeholder="Unesite vrijednost"
                          />
                        </Form.Item>

                        <Form.Item
                          colon={false}
                          name="troskovi-prva"
                          label="Dodatni troškovi (1. godina)"
                          initialValue={
                            !isAddOffer ? offerToEdit?.troskoviFirst : null
                          }
                          onChange={(e) => setRecalculateAdditionalCosts(e)}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Unesite vrijednost!",
                          //   },
                          // ]}
                        >
                          <InputNumber
                            className="w-full"
                            parser={(value) => parserNumber(value)}
                            placeholder="Unesite vrijednost"
                          />
                        </Form.Item>

                        <Form.Item
                          colon={false}
                          name="troskovi-ostalo"
                          label="Dodatni troškovi (zbir ostalih godina)"
                          initialValue={
                            !isAddOffer ? offerToEdit?.troskoviOther : null
                          }
                          onChange={(e) => setRecalculateAdditionalCosts(e)}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Unesite vrijednost!",
                          //   },
                          // ]}
                        >
                          <InputNumber
                            className="w-full"
                            parser={(value) => parserNumber(value)}
                            placeholder="Unesite vrijednost"
                          />
                        </Form.Item>

                        <Form.Item
                          colon={false}
                          name="kilometraza"
                          label="Kilometraza"
                          initialValue={
                            !isAddOffer ? offerToEdit?.kilometraza : null
                          }
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Unesite vrijednost!",
                          //   },
                          // ]}
                        >
                          <InputNumber
                            className="w-full"
                            max={30000}
                            parser={(value) => parserNumber(value)}
                            placeholder="Unesite vrijednost"
                          />
                        </Form.Item>
                      </>
                    )}

                    {/*  */}

                    <div className="flex gap-4">
                      <Form.Item
                        colon={false}
                        label="Trošak obrade"
                        name="obrada-%"
                        rules={[
                          {
                            required: true,
                            message: "Obavezno polje!",
                          },
                        ]}
                      >
                        <InputNumber
                          onChange={onChangeTrosakObrade}
                          type="number"
                          className="w-full mr-3"
                          min={supplier?.minProcessingFee}
                          max={supplier?.maxProcessingFee}
                          suffix="%"
                        />
                      </Form.Item>

                      <Form.Item
                        initialValue={!isAddOffer && offerToEdit?.processingFee}
                        colon={false}
                        label=" "
                        name="obrada"
                        rules={[
                          {
                            required: true,
                            message: "Obavezno polje!",
                          },
                        ]}
                      >
                        <InputNumber
                          formatter={(value) => formatNumber(value)}
                          parser={(value) => parserNumber(value)}
                          disabled
                          className="w-full"
                        />
                      </Form.Item>
                    </div>
                    <Form.Item
                      initialValue={glavnica}
                      className={styles.label}
                      colon={false}
                      label="GLAVNICA"
                      name="glavnica"
                    >
                      <InputNumber
                        formatter={(value) => formatNumber(value)}
                        parser={(value) => parserNumber(value)}
                        disabled
                        className="w-full"
                        min={0}
                      />
                    </Form.Item>

                    <Form.Item
                      // initialValue={offerToEdit && offerToEdit.installment}
                      className={styles.label}
                      colon={false}
                      label="RATA"
                      name="rata"
                      rules={[
                        {
                          required: true,
                          message: "Obavezno polje!",
                        },
                      ]}
                    >
                      <InputNumber
                        formatter={(value) => formatNumber(value)}
                        parser={(value) => parserNumber(value)}
                        disabled
                        className="w-full"
                        min={0}
                      />
                    </Form.Item>

                    {kasko && (
                      <Form.Item
                        initialValue="123"
                        colon={false}
                        label="KASKO"
                        name="kasko"
                        rules={[
                          {
                            required: true,
                            message: "Obavezno polje!",
                          },
                        ]}
                      >
                        <Input disabled type="number" min={0} />
                      </Form.Item>
                    )}

                    <Form.Item>
                      <Button
                        htmlType="submit"
                        className="text-sm text-white bg-light-blue font-medium w-[132px]  border-light-blue shadow-sm mt-1"
                      >
                        {!dodatneInfo ? "SPREMI" : "IDUĆI KORAK"}
                      </Button>
                    </Form.Item>
                  </div>
                </Col>

                <ModalProvizija
                  isModalOpen={isProvizijaModalOpen}
                  setIsModalOpen={setIsProvizijaModalOpen}
                  brutoProvizija={trosakObradeInputField * 0.5}
                  currency={activeCurrency}
                />
              </Row>
            </Form>
          </div>
        </>
      ) : (
        <DodatneInformacije
          podacioKlijentu={podacioKlijentu}
          onFinish={onFinishDodatneInfo}
          goBack={goBack}
          offerToEdit={offerToEdit}
        />
      )}
    </div>
  );
};

export default WebKalkulator;
